import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { ZitadelServiceUser } from "@src/types/user-management";

export interface PutUpdateServiceUsersResult {
  success: boolean;
  data?: ZitadelServiceUser;
  error?: string;
}

export const patchUpdateServiceUserUseCase = async (
  user: Partial<ZitadelServiceUser>,
): Promise<PutUpdateServiceUsersResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.patchUpdateServiceUser(namespace, user);

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(
        error,
        "Failed to update service user. Please try again later.",
      ).message,
    };
  }
};
